/** API key set in index.html from env() before React boots. */
export const getAmplitudeApiKey = (): string | undefined => {
  const key = window.AMPLITUDE_API_KEY
  if (!key || key.charAt(0) === '%') {
    return undefined
  }
  return key
}
